module.exports = __webpack_public_path__ + "static/media/robertKathyCarol56.1d2ae4a8.png";